export const cssVariables = {
  colors: {
    inputBorder: "var(--colors-input-border)",
    inputBackground: "var(--colors-input-background)",
    primary1: "var(--colors-primary1)",
    primary2: "var(--colors-primary2)",
    carbonBlack: "var(--colors-carbon-black)",
    eyGray: "var(--colors-gray-box)",
    eyGray2: "var(--colors-light-gray-box)",
    lightGray: "var(--colors-ultra-light-gray-box)",
    eyOffBlack: "var(--colors-ey-off-black)",
    eyOffWhite: "var(--colors-ey-off-white)",
    eyBlack: "var(--colors-ey-black)",
    white: "var(--colors-white)",
    black: "var(--colors-black)",
    eyDarkGreen: "var(--colors-ey-dark-green)",
    eyNotification: "var(--colors-ey-notification)",
    eyNotificationRed: "var(--colors-ey-notification-red)",
    requiredRed: "var(--colors-required-red)",
  },
};

export const HeaderHeight = "4rem";
